import { render, staticRenderFns } from "./chooseSalonDialog.vue?vue&type=template&id=635c28ea&scoped=true"
import script from "./chooseSalonDialog.vue?vue&type=script&lang=js"
export * from "./chooseSalonDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseSalonDialog.vue?vue&type=style&index=0&id=635c28ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c28ea",
  null
  
)

export default component.exports